import { useQuery } from "@tanstack/react-query";
import { generateContentSearch } from "@/apis/naniexpert/services/genai";
import type { GenerateContentSearchResponse } from "@/types/apis/naniexpert";

export const GENERATE_CONTENT_SEARCH_QUERY_KEY = [
  "naniexpert",
  "generateContentSearch",
] as const;

export const useGenerateContentSearchPolling = (uid: string | null) => {
  return useQuery({
    queryKey: [...GENERATE_CONTENT_SEARCH_QUERY_KEY, uid],
    queryFn: () => generateContentSearch({ uid: uid! }),
    enabled: !!uid,
    refetchInterval: (query) => {
      const data = query.state.data as
        | GenerateContentSearchResponse
        | undefined;
      if (data?.gradestatus === "Finish") return false;
      return 1000;
    },
  });
};
